import TrashIcon from 'assets/icons/trash.svg';
import { HintField, InputField, MyCheckbox } from 'components';
import InfoTooltip from 'components/InfoTooltip';
import { getIn } from 'formik';
import moment from 'moment';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import { fontConfig } from "theme/fontConfig";

const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

const ttlStyle = { fontFamily: fontConfig.EventsTtlFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 };
const inputTitleStyle = { fontFamily: fontConfig.EventsInputTitleFont.family, fontWeight: '400', fontSize: '12px', lineHeight: '18px', color: '#4F4F4F' };

const TLabel = ({ text, mandatory }) => (
  <label style={ttlStyle}>
    {text}{mandatory && <span style={{ color: 'red' }}> *</span>}
  </label>
);

const OptionalTypesItems = ({ formik, index, variantIndex, removeVariantHandler, acceptNumbersAndGtZero, showVariantName = false }) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();
  const variants = formik.values?.prices?.[index]?.variantInfo || [];
  const currentVariant = variants[variantIndex];
  const isMultiDateVariant = currentVariant?.isMultiDateVariant;
  const isGroupMultiDate = formik.values?.multiDateEvent && formik.values?.registrationType === 'group';

  const isAnotherOpenAmountSelected = variants.some(
    (v, i) => v?.openAmount && i !== variantIndex
  );

  const isAddons = formik.values?.prices?.[index]?.type === 'Addons';

  const namePath = `prices[${index}].variantInfo[${variantIndex}].name`;

  const handleVariantNameChange = (e) => {
    const newName = e?.target?.value;
    formik.setFieldValue(namePath, newName, true);
    formik.setFieldTouched(namePath, true, false);
  };

  if (isAddons) {
    return (
      <>
        <Row style={{ marginBottom: "8px", position: "relative" }}>
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text="Variant" mandatory />
              <InfoTooltip text="A label to identify this add-on option. E.g., 'Vegetarian Meal', 'VIP Parking', 'T-Shirt Size M'." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C' }}
              mandatory={true}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].name`}
              placeholder="Variant"
              checkValidation={true}
              maxLength={50}
              value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.name || ""}
              handleChange={handleVariantNameChange}
              onBlur={formik.handleBlur}
              onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
            />
          </Col>

          <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
              <MyCheckbox
                title="Members only"
                checked={isGroupMultiDate && !formik.values?.allowNonMembers ? true : (formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.forMemberOnly || false)}
                disabled={isGroupMultiDate && !formik.values?.allowNonMembers}
                handlechange={(e) =>
                  formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].forMemberOnly`, e.target.checked)
                }
              />
              <InfoTooltip text="Restrict this add-on variant to members only. Require users to log in before accessing this variant." style={{ marginBottom: '8px' }} />
            </div>
          </Col>

          <div
            className="optional_type-remove-icon"
            onClick={() => variants.length > 1 && removeVariantHandler(index, variantIndex)}
            style={{ opacity: variants.length <= 1 ? 0.3 : 1, cursor: variants.length <= 1 ? 'not-allowed' : 'pointer' }}
          >
            <img src={TrashIcon} alt="" />
          </div>
        </Row>

        <Row style={{ marginBottom: "8px" }}>
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text="Quantity" mandatory />
              <InfoTooltip text="Number of this add-on available across all registrations. E.g., 30 parking passes, 50 meal tickets." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C' }}
              mandatory={true}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].quantity`}
              placeholder="Quantity"
              checkValidation={true}
              value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.quantity || ""}
              handleChange={(e) => {
                const value = acceptNumbersAndGtZero(e?.target?.value.match(regex)?.[0])
                if (!formik?.values?.eventDetails?.infiniteCapacity && formik.values?.prices?.[index]?.type === 'Tickets' && value > formik.values?.eventDetails?.maximumCapacity) return;
                if (value > 10000) return;
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, value)
              }}
              onBlur={formik.handleBlur}
              onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
              disabled={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
            />
          </Col>

          <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
              <MyCheckbox
                title="No Limit"
                checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity || false}
                disabled={formik.values?.prices?.[index]?.limitType === 'checkbox' || formik.values?.prices?.[index]?.isRequired === true}
                handlechange={(e) => {
                  formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].infiniteQuantity`, e.target.checked)
                    .then(() => formik.validateForm());
                  if (e.target.checked) {
                    formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, '');
                    formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].quantity`, false);
                  }
                }}
              />
              <InfoTooltip text="Check to remove the quantity cap for this add-on variant, allowing unlimited selections." style={{ marginBottom: '8px' }} />
            </div>
          </Col>
        </Row>

        <Row style={{ marginBottom: "20px" }}>
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount ? "Min. Amount" : "Amount"} mandatory />
              <InfoTooltip text="The price attendees pay for this add-on variant." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C' }}
              mandatory={true}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].amount`}
              placeholder={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount ? "Min. Amount" : "Amount"}
              checkValidation={true}
              value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.amount || ""}
              handleChange={(e) => {
                const { value } = e.target;
                const updatedValue = value.match(regex)?.[0] >= 0 ? value.match(regex)?.[0] : '';
                if (parseFloat(updatedValue) > 1000000) return;
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].amount`, updatedValue)
              }}
              onBlur={formik.handleBlur}
              onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
            />
          </Col>

          <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
              <MyCheckbox
                title="Open Amount"
                checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount || false}
                disabled={
                  !formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount &&
                  isAnotherOpenAmountSelected
                }
                handlechange={(e) =>
                  formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].openAmount`, e.target.checked)
                }
              />
              <InfoTooltip text="Allow attendees to enter their own amount for this variant. The amount field becomes a minimum. E.g., A 'Donation' variant where attendees pay at least $10 but can give more." style={{ marginBottom: '8px' }} />
            </div>
          </Col>
        </Row>
        {variantIndex !== variants.length - 1 && (
          <hr className="w-100 mb-5" style={{ borderBottom: 'dashed 1px #002E5C', opacity: '0.2' }} />
        )}
      </>
    );
  }

  if (isMultiDateVariant) {
    const formattedDate = currentVariant?.eventDate
      ? moment.utc(currentVariant.eventDate).format('MM/DD/YYYY hh:mm A')
      : '';
    return (
      <>
        <Row style={{ marginBottom: '8px', position: 'relative' }}>
          {showVariantName && (
            <Col className="col-sm-6">
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                <TLabel text="Variant" mandatory />
                <InfoTooltip text="A label to identify this ticket tier. E.g., 'Early Bird', 'VIP', 'Student', 'General Admission'." />
              </div>
              <InputField
                titleStyle={inputTitleStyle}
                style={{ color: '#002E5C' }}
                mandatory={true}
                formik={formik}
                title="none"
                name={`prices[${index}].variantInfo[${variantIndex}].name`}
                placeholder="Variant"
                checkValidation={true}
                maxLength={50}
                value={currentVariant?.name || ''}
                handleChange={handleVariantNameChange}
                onBlur={formik.handleBlur}
                onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
              />
            </Col>
          )}
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text="Date/Hour" />
              <InfoTooltip text="The specific event date and time this ticket applies to. Auto-populated for multi-date events." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C', background: '#f6f6f6' }}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].eventDate`}
              placeholder="Date/Hour"
              value={formattedDate}
              disabled={true}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: '8px' }}>
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text="Quantity" mandatory />
              <InfoTooltip text="Number of tickets available for this date variant, capped by maximum event capacity. E.g., 50 Early Bird spots for Day 1." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C' }}
              mandatory={true}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].quantity`}
              placeholder="Quantity"
              checkValidation={true}
              value={currentVariant?.quantity || ''}
              handleChange={(e) => {
                const value = acceptNumbersAndGtZero(e?.target?.value.match(regex)?.[0]);
                if (!formik?.values?.eventDetails?.infiniteCapacity && value > formik.values?.eventDetails?.maximumCapacity) return;
                if (value > 10000) return;
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, value);
              }}
              onBlur={formik.handleBlur}
              onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
              disabled={currentVariant?.infiniteQuantity}
            />
          </Col>
          <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
              <MyCheckbox
                title="No Limit"
                name="infiniteQuantity"
                handlechange={(e) => {
                  formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].infiniteQuantity`, e.target.checked);
                  if (e.target.checked) {
                    formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, '');
                    formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].quantity`, false);
                  }
                }}
                checked={currentVariant?.infiniteQuantity || false}
              />
              <InfoTooltip text="Check to remove the quantity cap, allowing unlimited registrations for this ticket date variant." style={{ marginBottom: '8px' }} />
            </div>
          </Col>
        </Row>
        <Row style={{ marginBottom: '20px' }}>
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text="Amount" mandatory />
              <InfoTooltip text="The price attendees pay for this ticket on this specific date. E.g., $25 for Day 1 Early Bird, $50 for Day 2 VIP." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C' }}
              mandatory={true}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].amount`}
              placeholder="Amount"
              checkValidation={true}
              value={currentVariant?.amount || ''}
              handleChange={(e) => {
                const { value } = e.target;
                const updatedValue = value.match(regex)?.[0] >= 0 ? value.match(regex)?.[0] : '';
                if (parseFloat(updatedValue) > 1000000) return;
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].amount`, updatedValue);
              }}
              onBlur={formik.handleBlur}
              onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
            />
          </Col>
          {(orgDetails?.memberPortal && formik?.values?.allowNonMembers) && (
            <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                <MyCheckbox
                  title="Members only"
                  name="forMemberOnly"
                  handlechange={(e) =>
                    formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].forMemberOnly`, e.target.checked)
                  }
                  checked={currentVariant?.forMemberOnly || false}
                />
                <InfoTooltip text="Restrict this ticket tier to members only. Require users to log in before accessing this variant." style={{ marginBottom: '8px' }} />
              </div>
            </Col>
          )}
        </Row>
      </>
    );
  }

  const isIndividualMultiDate = formik.values?.multiDateEvent && formik.values?.registrationType === 'individual';

  const eventDateOptions = isIndividualMultiDate ? (() => {
    const primaryDate = formik.values?.date;
    const additionalDates = formik.values?.additionalEventDates || [];
    const allDates = [primaryDate, ...additionalDates.map(d => d.date)].filter(Boolean);
    return allDates.map(date => ({
      label: moment.utc(date).format('MM/DD/YYYY hh:mm A'),
      value: date,
    }));
  })() : [];

  if (isIndividualMultiDate) {
    return (
      <>
        {/* Row 1: Variant | Select Date */}
        <Row style={{ marginBottom: '8px', position: 'relative' }}>
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text="Variant" mandatory />
              <InfoTooltip text="A label to identify this ticket tier. E.g., 'Early Bird', 'VIP', 'Student', 'General Admission'." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C' }}
              mandatory={true}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].name`}
              placeholder="Variant"
              checkValidation={true}
              maxLength={50}
              value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.name}
              handleChange={handleVariantNameChange}
              onBlur={formik.handleBlur}
              onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
            />
          </Col>
          <Col className="col-sm-6">
            {currentVariant?.userAddedVariant ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                  <TLabel text="Date/Hour" />
                  <InfoTooltip text="The specific event date and time this ticket applies to. Auto-populated from the selected event date." />
                </div>
                <InputField
                  titleStyle={inputTitleStyle}
                  style={{ color: '#002E5C', background: '#f6f6f6' }}
                  formik={formik}
                  title="none"
                  name={`prices[${index}].variantInfo[${variantIndex}].eventDate`}
                  placeholder="Date/Hour"
                  value={currentVariant?.eventDate ? moment.utc(currentVariant.eventDate).format('MM/DD/YYYY hh:mm A') : ''}
                  disabled={true}
                />
              </>
            ) : (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '0.25rem' }}>
                  <TLabel text="Select Date" mandatory />
                  <InfoTooltip text="Choose which event date this ticket applies to. E.g., assign this variant to Day 1 or Day 2 of a multi-day conference." />
                </div>
                {(() => {
                  const eventDatePath = `prices[${index}].variantInfo[${variantIndex}].eventDate`;
                  const eventDateValue = getIn(formik.values, eventDatePath);
                  const eventDateTouched = getIn(formik.touched, eventDatePath);
                  const eventDateError = getIn(formik.errors, eventDatePath);
                  const showError = eventDateError && (eventDateTouched || formik.submitCount > 0);
                  return (
                    <>
                      <Select
                        placeholder="Select Date"
                        options={eventDateOptions}
                        value={eventDateValue ? { label: moment.utc(eventDateValue).format('MM/DD/YYYY hh:mm A'), value: eventDateValue } : null}
                        onChange={(option) => formik.setFieldValue(eventDatePath, option?.value)}
                        onBlur={() => formik.setFieldTouched(eventDatePath, true)}
                        styles={{
                          control: (styles) => ({
                            ...styles,
                            backgroundColor: '#F3F6F9',
                            borderColor: showError ? '#dc3545' : '#F3F6F9',
                            height: '48px',
                            cursor: 'pointer',
                          }),
                        }}
                      />
                      {showError && <HintField error={eventDateError} />}
                    </>
                  );
                })()}
              </>
            )}
          </Col>
          {currentVariant?.userAddedVariant && (
            <div
              className="optional_type-remove-icon"
              onClick={() => removeVariantHandler(index, variantIndex)}
              style={{ cursor: 'pointer' }}
            >
              <img src={TrashIcon} alt="" />
            </div>
          )}
        </Row>
        {/* Row 2: Quantity | No Limit */}
        <Row style={{ marginBottom: '8px' }}>
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text="Quantity" mandatory />
              <InfoTooltip text="Number of tickets available for this tier, capped by maximum event capacity. E.g., 50 Early Bird spots, 20 VIP spots." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C' }}
              mandatory={true}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].quantity`}
              placeholder="Quantity"
              checkValidation={true}
              value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.quantity}
              handleChange={(e) => {
                const value = acceptNumbersAndGtZero(e?.target?.value.match(regex)[0]);
                if (!formik?.values?.eventDetails?.infiniteCapacity && formik.values?.prices?.[index]?.type === 'Tickets' && value > formik.values?.eventDetails?.maximumCapacity) return;
                if (value > 10000) return;
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, value);
              }}
              onBlur={formik.handleBlur}
              onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
              disabled={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
            />
          </Col>
          <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
              <MyCheckbox
                title="No Limit"
                name="infiniteQuantity"
                handlechange={(e) => {
                  formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].infiniteQuantity`, e.target.checked);
                  if (e.target.checked) {
                    formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, '');
                    formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].quantity`, false);
                  }
                }}
                checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
              />
              <InfoTooltip text="Check to remove the quantity cap, allowing unlimited registrations for this ticket tier." style={{ marginBottom: '8px' }} />
            </div>
          </Col>
        </Row>
        {/* Row 3: Amount | Members Only */}
        <Row style={{ marginBottom: '20px' }}>
          <Col className="col-sm-6">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
              <TLabel text="Amount" mandatory />
              <InfoTooltip text="The price attendees pay for this ticket tier. E.g., $25 for Early Bird, $75 for VIP." />
            </div>
            <InputField
              titleStyle={inputTitleStyle}
              style={{ color: '#002E5C' }}
              mandatory={true}
              formik={formik}
              title="none"
              name={`prices[${index}].variantInfo[${variantIndex}].amount`}
              placeholder="Amount"
              checkValidation={true}
              value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.amount}
              handleChange={(e) => {
                const { value } = e.target;
                const updatedValue = value.match(regex)[0] >= 0 ? value.match(regex)[0] : '';
                if (parseFloat(updatedValue) > 1000000) return;
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].amount`, updatedValue);
              }}
              onBlur={formik.handleBlur}
              onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
            />
          </Col>
          {(orgDetails?.memberPortal && formik?.values?.allowNonMembers) && (
            <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                <MyCheckbox
                  title="Members only"
                  name="forMemberOnly"
                  handlechange={(e) =>
                    formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].forMemberOnly`, e.target.checked)
                  }
                  checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.forMemberOnly}
                />
                <InfoTooltip text="Restrict this ticket tier to members only. Require users to log in before accessing this variant." style={{ marginBottom: '8px' }} />
              </div>
            </Col>
          )}
        </Row>
      </>
    );
  }

  return (
    <>
      <Row style={{ marginBottom: '8px', position: 'relative' }}>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <TLabel text="Variant" mandatory />
            <InfoTooltip text="A label to identify this ticket tier. E.g., 'Early Bird', 'VIP', 'Student', 'General Admission'." />
          </div>
          <InputField
            titleStyle={inputTitleStyle}
            style={{ color: '#002E5C' }}
            mandatory={true}
            formik={formik}
            title="none"
            name={`prices[${index}].variantInfo[${variantIndex}].name`}
            placeholder="Variant"
            checkValidation={true}
            maxLength={50}
            value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.name}
            handleChange={handleVariantNameChange}
            onBlur={formik.handleBlur}
            onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
          />
        </Col>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <TLabel text="Quantity" mandatory />
            <InfoTooltip text="Number of tickets available for this tier, capped by maximum event capacity. E.g., 50 Early Bird spots, 20 VIP spots." />
          </div>
          <InputField
            titleStyle={inputTitleStyle}
            style={{ color: '#002E5C' }}
            mandatory={true}
            formik={formik}
            title="none"
            name={`prices[${index}].variantInfo[${variantIndex}].quantity`}
            placeholder="Quantity"
            checkValidation={true}
            value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.quantity}
            handleChange={(e) => {
              const value = acceptNumbersAndGtZero(e?.target?.value.match(regex)[0])
              if (!formik?.values?.eventDetails?.infiniteCapacity && formik.values?.prices?.[index]?.type === 'Tickets' && value > formik.values?.eventDetails?.maximumCapacity) return;
              if (value > 10000) return;
              formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, value)
            }}
            onBlur={formik.handleBlur}
            onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
            disabled={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
          />
        </Col>
        <div
          className="optional_type-remove-icon"
          onClick={() => variants.length > 1 && removeVariantHandler(index, variantIndex)}
          style={{ opacity: variants.length <= 1 ? 0.3 : 1, cursor: variants.length <= 1 ? 'not-allowed' : 'pointer' }}
        >
          <img src={TrashIcon} alt="" />
        </div>
      </Row>
      <Row style={{ marginBottom: '20px' }}>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <TLabel text="Amount" mandatory />
            <InfoTooltip text="The price attendees pay for this ticket tier. E.g., $25 for Early Bird, $75 for VIP." />
          </div>
          <InputField
            titleStyle={inputTitleStyle}
            style={{ color: '#002E5C' }}
            mandatory={true}
            formik={formik}
            title="none"
            name={`prices[${index}].variantInfo[${variantIndex}].amount`}
            placeholder={"Amount"}
            checkValidation={true}
            value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.amount}
            handleChange={(e) => {
              const { value } = e.target;
              const updatedValue = value.match(regex)[0] >= 0 ? value.match(regex)[0] : '';
              if (parseFloat(updatedValue) > 1000000) return;
              formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].amount`, updatedValue)
            }}
            onBlur={formik.handleBlur}
            onKeyPress={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
          />
        </Col>
        <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'nowrap' }}>
            <MyCheckbox
              title="No Limit"
              name="infiniteQuantity"
              handlechange={(e) => {
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].infiniteQuantity`, e.target.checked);
                if (e.target.checked) {
                  formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, '');
                  formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].quantity`, false);
                }
              }}
              checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
            />
            <InfoTooltip text="Check to remove the quantity cap, allowing unlimited registrations for this ticket tier." style={{ marginBottom: '8px' }} />
            {(orgDetails?.memberPortal && (formik?.values?.allowNonMembers || isGroupMultiDate)) && (
              <>
                <MyCheckbox
                  title="Members only"
                  name="forMemberOnly"
                  disabled={isGroupMultiDate && !formik.values?.allowNonMembers}
                  handlechange={(e) =>
                    formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].forMemberOnly`, e.target.checked)
                  }
                  checked={isGroupMultiDate && !formik.values?.allowNonMembers ? true : (formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.forMemberOnly || false)}
                />
                <InfoTooltip text="Restrict this ticket tier to members only. Require users to log in before accessing this variant." style={{ marginBottom: '8px' }} />
              </>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default OptionalTypesItems;
